import { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Paper, Typography, Box, Button, Grid, useTheme } from '@mui/material';
import { useGetDataAssetsQuery } from '../../../../features/data_assets/dataAssetsApiSlice';
import PulseLoader from 'react-spinners/PulseLoader';
import { Link } from 'react-router-dom';
import { tokens } from '../../../../theme';


const RealTimeServices = () => {
    const {
        data: dataAssets,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetDataAssetsQuery('dataAssets', {
        pollingInterval: 15000, // Poll every 15 seconds
        refetchOnFocus: true, // Refetch data when the component is focused
        refetchOnMountOrArgChange: true, // Refetch data when the component is mounted or the query args change
    });
    const theme = useTheme();  
    const colors = tokens(theme.palette.mode);

    const [selectedDataAsset, setSelectedDataAsset] = useState(null);

    const handleRowClick = (row) => {
        setSelectedDataAsset(row);
      };

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <PulseLoader color={"#FFF"} />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <Typography variant="h6" color="error">
                    Error fetching data assets: {error.message}
                </Typography>
            </Box>
        );
    }

    const da_ents = dataAssets.entities;
    const allDataAssets = Object.values(da_ents);

    const realTimeServices = Array.isArray(allDataAssets)
        ? allDataAssets.filter((asset) => asset.assetType === "Real-Time")
        : [];

    const columnsRealTime = [
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'usage', headerName: 'Usage', flex: 1 },
        {
            field: 'status',
            headerName: 'Status Light',
            flex: 1,
            renderCell: (params) => {
                const { updateCadence } = params.row;
                const currentTimestamp = Date.now();
                const lastUpdatedTimestamp = updateCadence.last_updated_timestamp_utc
                    ? new Date(updateCadence.last_updated_timestamp_utc).getTime()
                    : 0;
                const diffMinutes = Math.floor(
                    (currentTimestamp - lastUpdatedTimestamp) / (1000 * 60)
                );

                if (diffMinutes > updateCadence.realTimeRefreshRate) {
                    return (
                        <Box display="flex" alignItems="center">
                            <Box
                                width={10}
                                height={10}
                                borderRadius="50%"
                                bgcolor="red"
                                mr={1}
                            />
                            Offline
                        </Box>
                    );
                }
                return (
                    <Box display="flex" alignItems="center">
                        <Box
                            width={10}
                            height={10}
                            borderRadius="50%"
                            bgcolor="green"
                            mr={1}
                        />
                        Online
                    </Box>
                );
            },
        },
    ];
    return (
        <Paper
            sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
                minHeight: '33%',
                borderRadius: '20px',
                backgroundColor: colors.grey[700]
            }}
        >
            <Typography variant="h4" gutterBottom sx={{ alignSelf: 'flex-start' }}>
                <Link style={{ color: colors.blueAccent[200]}} to="/console/data">Real Time Services</Link>
            </Typography>
            <Box
                height="30vh"
                sx={{
                    '& .MuiDataGrid-root': {
                        border: 'none',
                    },
                    '& .MuiDataGrid-cell': {
                        borderBottom: 'none',
                    },
                }}
            >
                <DataGrid
                    rows={realTimeServices}
                    columns={columnsRealTime}
                    getRowId={(row) => row.data_asset_id || row._id}
                    disableSelectionOnClick
                    onRowClick={(params) => handleRowClick(params.row)}
                />
            </Box>
        </Paper>
    )
}

export default RealTimeServices